import { Box, CircularProgress, Dialog,  DialogContent,  DialogTitle,  Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useUser } from '../../../context/UserContext';
import Supabase from '../../../backend/client';
import { getuuid } from '../../../util/functions';
import { errorToaster, successToaster } from '../../../util/toaster';

const BACKEND_URL = "https://api.tradefolio.com";

const BuySimmulation = ({
    open,
    handleClose,
    algoDetail,
}) => {
  const user = useUser();
  const userId = user?.user?.id;

  const getdetails = async (buy, sell, stocks) => {
    try {
      const used_counter = algoDetail?.used_counter + 1;
      const updateAlgo = await Supabase
        .from('algos')
        .update({ used_counter })
        .eq('id', algoDetail?.id)
        .select();

      await fetch(`${BACKEND_URL}/subscribe-algo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          algo_id: algoDetail?.id,
          user_id: userId,
          buy_logic: buy,
          sell_logic: sell,
          stocks: stocks
        }),
      });

      const {data, error} = await Supabase.from('my_stock_cart').insert([
        {
          algo_id: algoDetail?.id,
          user_id: userId,
          txn_id: getuuid('TXN')
        }
      ])
      .select();
      
      if(error){
        handleClose();
        return errorToaster(error?.message);
      }
      
      successToaster("Algo Subscribed successfully.");
      handleClose();
    } catch (error) {
      console.error("Error in subscription process:", error);
      errorToaster("Failed to subscribe to algo. Please try again.");
      handleClose();
    }
  }

  useEffect(() => {
    const stocks = JSON.parse(algoDetail?.backtest_details)?.stocks || [];
    const buy = JSON.parse(algoDetail?.left_logic);
    const sell = JSON.parse(algoDetail?.right_logic);
    getdetails(buy, sell, stocks);
  }, []);

  return (
    <Dialog onClose={handleClose} open={open} disableEscapeKeyDown={true} >
      <DialogTitle>Renting Algo</DialogTitle>
      <DialogContent>
        <Box sx={{ textAlign: 'center', p: 4 }}>
          <CircularProgress />
          <Typography variant="body1" sx={{ mt: 2 }}>
            Processing your subscription. Please wait...
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default BuySimmulation